// extracted by mini-css-extract-plugin
export default {"quickInfo":"_185wkpe"};